<template>
  <div>
    <form class="space-y-6" @submit.prevent="recaptcha" v-if="!success">
      <fieldset class="w-full" v-show="!userType">
        <legend class="block text-sm font-medium leading-5 text-hurst-blue">I am a:</legend>
        <div class="mt-1 flex items-center space-x-10">
          <template v-if="userType">
            <div class="flex items-center">
              <input type="radio" name="userType" id="faculty" value="faculty" :checked="userType == 'faculty'"
                     class="h-4 w-4 border-2 border-hurst-blue text-hurst-blue focus:ring-hurst-blue"
                     :class="[ userType == 'student' || userType == 'healthcare' ? 'hidden' : '']" v-model="type">
              <label for="faculty"
                     class="ml-3 block text-sm font-medium leading-6 text-hurst-blue"
                     :class="[ userType == 'student' || userType == 'healthcare' ? 'hidden' : '']">Faculty</label>
            </div>
            <div class="flex items-center">
              <input type="radio" name="userType" id="student" value="student" :checked="userType == 'student'"
                     class="h-4 w-4 border-2 border-hurst-blue text-hurst-blue focus:ring-hurst-blue"
                     :class="[ userType == 'faculty' || userType == 'healthcare' ? 'hidden' : '']" v-model="type">
              <label for="student"
                     class="ml-3 block text-sm font-medium leading-6 text-hurst-blue"
                     :class="[ userType == 'faculty' || userType == 'healthcare' ? 'hidden' : '']">Student</label>
            </div>
            <div class="flex items-center">
              <input type="radio" name="userType" id="healthcare" value="healthcare" :checked="userType == 'healthcare'"
                     class="h-4 w-4 border-2 border-hurst-blue text-hurst-blue focus:ring-hurst-blue"
                     :class="[ userType == 'faculty' || userType == 'student' ? 'hidden' : '']" v-model="type">
              <label for="healthcare"
                     class="ml-3 block text-sm font-medium leading-6 text-hurst-blue"
                     :class="[ userType == 'faculty' || userType == 'student' ? 'hidden' : '']">Healthcare</label>
            </div>
          </template>
          <template v-else>
            <div class="flex items-center">
              <input type="radio" name="userType" id="faculty" value="faculty" v-model="type" required="required"
                     class="h-4 w-4 border-2 border-hurst-blue text-hurst-blue focus:ring-hurst-blue"
              >
              <label for="faculty"
                     class="ml-3 block text-sm font-medium leading-6 text-hurst-blue"
              >Faculty</label>
            </div>
            <div class="flex items-center">
              <input type="radio" name="userType" id="student" value="student" v-model="type" required="required"
                     class="h-4 w-4 border-2 border-hurst-blue text-hurst-blue focus:ring-hurst-blue"
              >
              <label for="student"
                     class="ml-3 block text-sm font-medium leading-6 text-hurst-blue"
              >Student</label>
            </div>
          </template>
        </div>
      </fieldset>
      <div class="w-full">
        <label class="block text-sm font-medium leading-5 text-hurst-blue">First Name</label>
        <div class="">
          <input type="text" name="firstName" class="appearance-none block w-full px-3 py-2  border border-hurst-blue rounded shadow-inner placeholder-brand-gray-500 focus:outline-none focus:ring-hurst-teal focus:border-hurst-teal transition duration-150 ease-in-out sm:text-sm sm:leading-5 border-brand-gray-300" required="required" v-model="form.firstName"/>
        </div>
      </div>
      <div class="w-full">
        <label class="block text-sm font-medium leading-5 text-hurst-blue">Last Name</label>
        <div class="">
          <input type="text" name="lastName" class="appearance-none block w-full px-3 py-2  border border-hurst-blue rounded shadow-inner placeholder-brand-gray-500 focus:outline-none focus:ring-hurst-teal focus:border-hurst-teal transition duration-150 ease-in-out sm:text-sm sm:leading-5 border-brand-gray-300" required="required" v-model="form.lastName"/>
        </div>
      </div>
      <div class="w-full">
        <label class="block text-sm font-medium leading-5 text-hurst-blue">Email Address</label>
        <div class="">
          <div class="">
            <span class=""><i class="glyphicon glyphicon-envelope"></i></span>
            <input type="email" class="appearance-none block w-full px-3 py-2  border border-hurst-blue rounded shadow-inner placeholder-brand-gray-500 focus:outline-none focus:ring-hurst-teal focus:border-hurst-teal transition duration-150 ease-in-out sm:text-sm sm:leading-5 border-brand-gray-300" name="emailAddress" required="required" v-model="form.emailAddress"/>
          </div>
        </div>
      </div>
      <div class="w-full">
        <label class="block text-sm font-medium leading-5 text-hurst-blue">Phone</label>
        <div class="">
          <input type="tel" class="appearance-none block w-full px-3 py-2  border border-hurst-blue rounded shadow-inner placeholder-brand-gray-500 focus:outline-none focus:ring-hurst-teal focus:border-hurst-teal transition duration-150 ease-in-out sm:text-sm sm:leading-5 border-brand-gray-300" name="phone" v-model="form.phone"/>
        </div>
      </div>
      <div class="w-full" v-if="form.userType != 'healthcare'">
        <label class="block text-sm font-medium leading-5 text-hurst-blue" for="programType">Degree Type</label>
        <div class="">
          <select name="programType" id="programType"
                  class="form-select text-brand-gray-500 appearance-none block w-full px-3 py-2  border border-hurst-blue rounded shadow-inner placeholder-brand-gray-500 focus:outline-none focus:ring-hurst-teal focus:border-hurst-teal focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                  v-model="form.programType"
          >
            <option value="">-- Select Degree Type</option>
            <option value="ADN">ADN</option>
            <option value="BSN">BSN</option>
            <option value="LPN">LPN</option>
          </select>
        </div>
      </div>
      <div v-if="form.userType && form.userType == 'student'" class="w-full">
        <label class="block text-sm font-medium leading-5 text-hurst-blue">Graduation Date</label>
        <div class="">
          <v-date-picker
              :input-props='{
                            id: "gradDate",
                            // class: "",
                            placeholder: "Graduation Date"
                        }'
              is-dark
              color="indigo"
              v-model="graduationInput"
              class="appearance-none block w-full px-3 py-2  border border-hurst-blue rounded shadow-inner placeholder-brand-gray-500 focus:outline-none focus:ring-hurst-teal focus:border-hurst-teal transition duration-150 ease-in-out sm:text-sm sm:leading-5 border-brand-gray-300"></v-date-picker>
        </div>
      </div>
      <div class="w-full">
        <label v-if="userType == 'healthcare'" class="block text-sm font-medium leading-5 text-hurst-blue">Company's State or Province</label>
        <label v-else class="block text-sm font-medium leading-5 text-hurst-blue">Nursing School's State or Province</label>
        <div class="">
          <select id="nursingSchoolState"
                  class="form-select text-brand-gray-500 appearance-none block w-full px-3 py-2  border border-hurst-blue rounded shadow-inner placeholder-brand-gray-500 focus:outline-none focus:ring-hurst-teal focus:border-hurst-teal focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                  v-model="form.nursingSchoolState" @change="loadSchools">
            <option v-if="userType == 'healthcare'" value="" class="">Your Company's State or Province:</option>
            <option v-else value="" class="">Your Nursing School's State or Province:</option>
            <option value="non-us-ca" class="text-brand-gray-600">Outside of The US / Canada</option>
            <option disabled>----------------------------</option>
            <option class="text-brand-gray-600" v-for="state in stateProvince" :key="state.abbreviation"
                    :value="state.abbreviation">{{ state.name }}
            </option>
          </select>
        </div>
      </div>
      <div class="w-full" v-if="this.form.userType != 'healthcare'">
        <label class="block text-sm font-medium leading-5 text-hurst-blue">Nursing School</label>
        <div class="">
          <select id="nursingSchool"
                  class="form-select text-brand-gray-500 appearance-none block w-full px-3 py-2  border border-hurst-blue rounded shadow-inner placeholder-brand-gray-500 focus:outline-none focus:ring-hurst-teal focus:border-hurst-teal focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                  v-model="form.nursingSchoolId" :disabled="schools.length < 1">
            <option v-if="schools.length > 0" value="" class="">Select School:</option>
            <option v-else value="" class="" disabled>Select Your School's State</option>
            <option class="text-brand-gray-600" v-for="school in schools" :key="school.schoolId" :value="school.schoolId">
              {{ school.schoolName }}
            </option>
          </select>
        </div>
      </div>
      <div class="w-full" v-else>
        <label class="block text-sm font-medium leading-5 text-hurst-blue">Company</label>
        <div class="">
          <input type="text" name="companyName" class="w-full" required="required" v-model="form.companyName"/>
        </div>
      </div>
      <input type="hidden" name="event" :value="convention.conventionId"/>
      <div class="flex justify-center">
          <cart-button type="submit" class="w-full justify-center max-w-sm">Save</cart-button>
      </div>
    </form>
    <div v-if="success">
      <p>
        Thank you for visiting with us. We will contact you with more information soon.
      </p>
      <p class="text-brand-gray-600 text-sm">
        The form will reset in {{ formResetDelaySeconds }} seconds.
      </p>
    </div>
  </div>
</template>

<script>
import {range} from 'lodash/core';
import moment from 'moment';
import axios from 'axios';
import Swal from 'sweetalert2';

import Vue from 'vue'
import {VueReCaptcha} from 'vue-recaptcha-v3'

// For more options see below
Vue.use(VueReCaptcha, {siteKey: '6LfjgD4oAAAAANkZzyTDusefm63rGy-oMOCvGgDq'})

export default {
  name: "ConventionInfoForm",

  props: {
    stateProvince: {
      type: Array,
      required: true
    },
    convention: {
      type: Object,
      required: true
    },
    userType: String,
    recaptchaKey: String
  },

  data() {
    return {
      errors: {},
      form: {
        userType: this.userType,
        firstName: '',
        lastName: '',
        emailAddress: '',
        graduationDate: '',
        nursingSchoolId: '',
        companyName: null,
        nursingSchoolState: '',
        phone: '',
        programType: '',
        conventionId: this.convention.conventionId,
        recaptchaToken: null
      },
      graduationInput: '',
      schools: [],
      success: false,
      formResetDelay: 30000
    }
  },

  mounted() {
  },

  computed: {
    type: {
      get: function () {
        return this.userType;
      },
      set: function (value) {
        this.form.userType = value;
      }
    },
    formResetDelaySeconds() {
      return this.formResetDelay / 1000;
    }
  },

  watch: {
    graduationInput: function (newDate, oldDate) {
      this.form.graduationDate = moment(newDate).format('YYYY-MM-DD');
    }
  },

  methods: {
    async recaptcha() {
      Swal.fire({
        title: 'Please Wait',
        icon: 'info',
        html: 'Submitting<br/><i class="fal fa-spinner fa-spin fa-3x"></i>',
        showCloseButton: false,
        showConfirmButton: false,
      });
      // (optional) Wait until recaptcha has been loaded.
      await this.$recaptchaLoaded()

      // Execute reCAPTCHA with action "submit".
      const token = await this.$recaptcha('submit')

      // Do stuff with the received token.


      this.form.recaptchaToken = token;
      this.save(token);
    },

    async loadSchools() {
      try {
        const {data} = await axios.get(`/ajax/schoolByState/${this.form.nursingSchoolState}`);
        this.schools = data;
      } catch (e) {

      }
    },

    async save(token) {
      this.errors = {};
      await axios.post('/conventions/' + this.convention.conventionId, this.form).then((response) => {
        this.success = true;
        Swal.close();
        setTimeout(() => window.location.reload(), this.formResetDelay);
      }, (error) => {
        console.log(error);
        Swal.fire({
          title: 'Unauthorized',
          icon: 'warning',
          html: 'Your submission could not be completed. Please contact your Hurst representative for assistance.',
          showCloseButton: true,
          showConfirmButton: false,
        });
      });
    }
  }
}
</script>

<style scoped>

</style>